import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isSlotArea } from './is-slot-area.js'

export function getSlotAreaFields(value: unknown): SchemaField[] {
  return isSlotArea(value) ? value.fields : []
}
